import { Injectable } from '@angular/core';
import { createTraceparent } from '@zion/shared/observability-correlation';

@Injectable({ providedIn: 'root' })
export class TraceContextService {
  createTraceparent(): string {
    return createTraceparent((byteLength) => this.randomHex(byteLength));
  }

  private randomHex(byteLength: number): string {
    const bytes = new Uint8Array(byteLength);
    globalThis.crypto.getRandomValues(bytes);

    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
      '',
    );
  }
}
